<template lang="">
	<div id="content">
		<div class="global_area">
			<div class="path"><a href="#none">Home</a> &gt; <a href="#none">기타 관리</a> &gt; <strong>제휴기관 관리</strong></div>
			<h2 class="h_sub">제휴기관 관리</h2>
		</div>

    <PartnerManageListForm/>
  </div>
</template>

<script>
import PartnerManageListForm from '@/components/admin/etc/PartnerManageListForm.vue';

export default {
  components: {
    PartnerManageListForm
  }
}
</script>
<style lang="">
    
</style>